import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 28465 32854"
    {...props}
  >
    <path
      d="m18485 22289-4252-5863 7201 763 6372 7088-9321-1988zm9334-13692-9325 1975-4261 5855 7202-751 6384-7079zM14244 746l-2952 9063 2941 6618 2950-6614-2939-9067zm-11 15681-4253-5862L659 8576l6371 7089 7203 762zm-13 15681 2953-9063-2941-6619-2951 6614 2939 9068zM647 24257l9325-1975 4261-5855-7203 751-6383 7079z"
      style={{
        fill: "#000",
        stroke: "#fefefe",
        strokeWidth: 461.196,
      }}
      className="stroke1 fill"

    />
  </svg>
)
export default SvgComponent
